import * as React from "react";
import * as ReactDOM from "react-dom";

import diyLightTheme = require("../../material-ui/diyLightTheme");
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import { colors } from 'material-ui/styles';
import { autoprefixer } from '../../material-ui/autoprefixer';
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import OverlayMenuConfig from "../interfaces/OverlayMenuConfig";

interface OverlayMenuProps extends React.Props<OverlayMenu> {
    overlayMenuConfig?: OverlayMenuConfig;
    open: boolean;
    menuText: string;
    onToggleRequest: (open: boolean) => void;
    showMenuLabel: boolean;
    menuLabelMaxWidth: number;
}

export default class OverlayMenu extends React.Component<OverlayMenuProps, {}> {

    private transitionTimeout: number;

    getStyles() {
        return {
            menu: autoprefixer({
                marginRight: this.props.overlayMenuConfig ? (this.props.overlayMenuConfig.rightOffset) : 0,
                float: 'right',
                height: 36,
                background: colors.grey700,
                alignItems: 'center',
                display: 'flex',
                transform: 'translate3d(18px, 0, 0)',
                opacity: 0,
                transition: '',
                maxWidth: (this.props.menuLabelMaxWidth - 4)
            }),
            menuButton: {
                margin: -6,
            },
            menuLabelContainer: autoprefixer({
                paddingLeft: 12,
                paddingRight: 12,
                borderRight: "1px solid rgba(255,255,255,0.3)",
                minWidth: 67,
                display: "flex",
                height: "100%",
                alignItems: "center",
            }),
            menuLabel: {
                color: 'white',
                fontFamily: diyLightTheme.rawTheme.fontFamily,
                fontSize: 12,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        };
    }

    render() {
        let styles = this.getStyles();
        let disabledColor = diyLightTheme.rawTheme.palette.disabledColor;

        return (
            <div style={styles.menu} data-test-id="module-options-button" onTouchTap={this.onMenuClick}>
                {
                    this.props.showMenuLabel
                    ?
                    <div style={styles.menuLabelContainer} >
                        <span style={styles.menuLabel}>
                            {this.props.menuText}
                        </span>
                    </div>
                    :
                    null
                }
                {
                    <IconMenu
                        style={styles.menuButton}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        targetOrigin={{ vertical: "top", horizontal: "right" }}
                        onChange={this.onChange.bind(this)}
                        onRequestChange={this.onRequestChange}
                        open={this.props.open}
                        iconButtonElement={
                            <IconButton>
                                <MoreVertIcon color="white" />
                            </IconButton>
                        }
                        useLayerForClickAway={true}
                        >
                        {
                            this.props.overlayMenuConfig ?
                                this.props.overlayMenuConfig.menuItems.map((menuItem, index) => {
                                    if (menuItem.isDivider) {
                                        return (
                                            <Divider key={index} />
                                        );
                                    }
                                    const LeftIcon = menuItem.leftIcon;
                                    return (
                                        <MenuItem
                                            data-test-id={"module-menu-option-" + menuItem.name}
                                            key={index}
                                            value={`${index}`}
                                            primaryText={menuItem.primaryText}
                                            leftIcon={
                                                menuItem.disabled ?
                                                    <LeftIcon
                                                        color={disabledColor}
                                                        hoverColor={disabledColor} />
                                                    :
                                                    <LeftIcon />
                                            }
                                            disabled={menuItem.disabled}
                                            />
                                    );
                                })
                                :
                                null
                        }
                    </IconMenu>
                }
            </div>
        );
    }

    componentDidAppear() {
        const rootEl = ReactDOM.findDOMNode(this) as HTMLElement;
        this.transitionTimeout = setTimeout(function() {
            rootEl.style.opacity = "1";
            rootEl.style.transition = "all cubic-bezier(0.62, 0.28, 0.23, 0.99) 0.2s 0.2s";
            rootEl.style.transform = 'translate3d(0, 0, 0)';
        }, 0);
    }

    componentWillUnmount() {
        clearTimeout(this.transitionTimeout);
    }

    private onRequestChange = (open: boolean, reason: string) => {
        if (open) {
            // XXX prevent opening and immediate closing on touch devices
            // TODO fix this in material-ui and do a pull request
            // by sending the original event so we can fileter
            // here based on the event type
            setTimeout(() => {
                this.props.onToggleRequest(open);
            }, 50);
        } else {
            this.props.onToggleRequest(open);
        }
    };

    private onChange(event: React.SyntheticEvent<{}>, value: String) {
        const menuItemConfig = this.props.overlayMenuConfig.menuItems[Number(value)];
        menuItemConfig.onSelect.call(this, event.nativeEvent);
    }

    private onMenuClick = (e: React.SyntheticEvent<{}>) => {
        e.preventDefault();
        this.props.onToggleRequest(true);
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/OverlayMenu.tsx
 **/